module.exports = __webpack_public_path__ + "img/elk.83e52a6b.svg";